// The `locale` cookie, read without js-cookie. useTranslation / useI18n run in ~150 components on
// every render, and Cookies.get parses and decodes the whole cookie header each time — on this site
// that header is long (GTM, HubSpot, Meta, Clarity), which showed up as a measurable share of PDP
// script time on mobile. A single anchored regex reads just this one cookie.
const LOCALE_COOKIE = /(?:^|;\s*)locale=([^;]*)/;

export const readLocaleCookie = (): string => {
  if (typeof document === 'undefined') return 'en';
  const match = LOCALE_COOKIE.exec(document.cookie);
  if (!match?.[1]) return 'en';
  try {
    return decodeURIComponent(match[1]) || 'en';
  } catch {
    // A malformed escape would otherwise reach sdk.defaultConfigure as a locale.
    return 'en';
  }
};
